'use client'
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What services are included in your digital marketing offerings?",
    answer: "We provide a comprehensive range of services including SEO, social media marketing, PPC advertising, content marketing, email campaigns, influencer partnerships, and analytics — all designed to grow your online presence and sales."
  },
  {
    question: "How do you create a digital marketing strategy for my business?",
    answer: "We start by understanding your business goals, target audience, and competitors. Then we develop a customized strategy combining the most effective channels and tactics to maximize your ROI and brand awareness."
  },
  {
    question: "Can you help improve my website’s search engine ranking?",
    answer: "Absolutely. Our SEO experts optimize your website with keyword research, on-page SEO, technical fixes, link building, and content creation to boost your visibility and organic traffic."
  },
  {
    question: "How do you measure the success of digital marketing campaigns?",
    answer: "We track key performance indicators like traffic, conversions, engagement, cost per acquisition, and ROI. Regular reports keep you informed on campaign performance and optimization opportunities."
  },
  {
    question: "Do you offer ongoing support and campaign management?",
    answer: "Yes, we provide continuous monitoring, adjustments, and reporting to ensure your digital marketing efforts stay effective and aligned with your evolving business needs."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className='col text-center py-5 mt-5' data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>
      
      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level="3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span
                        className={`transition-colors duration-200 cursor-pointer 
                          hover:text-purple-600 
                          ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
                      >{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
